<template lang="html">
	<div class="layout">
		<TopNav />

		<div class="page-content">
			<transition mode="out-in">
				<router-view />
			</transition>
		</div>

		<CustomFooter />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	created() {},
	components: {
		TopNav: () => import('@/components/templates/nav'),
		CustomFooter: () => import('@/components/templates/footer'),
	},
	computed: {
		...mapGetters('auth', ['isAuthenticated']),
	},
	mounted() {},
};
</script>

<style lang="less">
.layout {
	display: flex;
	flex-direction: column;
	min-height: 100vh;

	.page-content {
		flex: 1;
		width: 100%;
		/* The navbar spacer in nav.vue now handles all the top spacing */
	}

	.white-content {
		background: var(--white);
		border-radius: 4px;
		border: solid 1px #e6eaee;
		padding: 40px 0;
		text-align: center;
		font-size: 14px;
		line-height: 24px;
		font-weight: 500;
		color: var(--ne-red);
	}
}
</style>
